module.exports = {"id":"198009","name":"Mattia Perin","rating":"84","photo":"./data/images/photos/3/198009.png","club":{"name":"Genoa","logo":"./data/images/clubs/Genoa.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MattiaPerin0.json
// module id = 2911
// module chunks = 0